import { defineMessage } from 'services/localization';

export const messages = {
    referenceFieldText: defineMessage('reference'),
    vendorFieldText: defineMessage('vendor'),
    purchaseOrderFieldText: defineMessage('purchase_order'),
    transactionDateFieldText: defineMessage('date'),
    postingPeriodFieldText: defineMessage('posting_period_1'),
    memoFieldText: defineMessage('memo'),
};
